import React, { useState } from "react";
import '../../assets/css/receiverdashboard/layout/ReceiverMasterLayout.css';
import ReceiverSideBar from "../../components/receiverdashboard/ReceiverSideBar";
import ReceiverTopbar from "../../screens/receiverdashboard/ReceiverTopBar";

const ReceiverMasterLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="rml-master-layout">

      {/* Sidebar — position:fixed hai, flow se bahar */}
      <ReceiverSideBar />

      {/* Main Content — margin-left se sidebar ke baad start hoga */}
      <div className="rml-main-content">

        <div className="rml-topbar-wrapper">
          <ReceiverTopbar onMenuToggle={toggleSidebar} userName="Fatima Ali" />
        </div>

        <div className="rml-content-area">
          {children}
        </div>

      </div>

      {sidebarOpen && (
        <div className="rml-sidebar-overlay" onClick={toggleSidebar} />
      )}

    </div>
  );
};

export default ReceiverMasterLayout;